module.exports = __webpack_public_path__ + "cart-feature-warranty/cart-feature-warranty-8643f5e96b28ae98e145556f3d2b7c58.png";